import { useState } from 'react';
import SearchBar from './searchBar';
import { API_ROUTES } from '../utils/api-routes';
import './homeSearch.css';

const stateFromProgramName: any = {
  california_first: 'CA',
  renew_pace_florida: 'FL',
};

function HomeSearch() {
  const [searchValue, setSearchValue] = useState<string | undefined>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [searched, setSearched] = useState<boolean>(false);
  const [found, setFound] = useState<boolean>(true);
  const [newResult, setNewResult] = useState<any>({});
  const [searchParams, setSearchValueParam] = useState<string | undefined>('');

  const fetchData = async (searchValueParam: any) => {
    if (searchValueParam) {
      setLoading(true);
      try {
        const response = await fetch(API_ROUTES.ELIGIBILITY_CHECK, {
          method: 'POST',
          body: JSON.stringify({ address: searchValueParam }),
        });
        const result = await response.json();
        setLoading(false);
        setSearchValue(searchValueParam);
        if (result.eligible) {
          const newResponse = await fetch(API_ROUTES.AVAILABILITY_CHECK, {
            method: 'POST',
            body: JSON.stringify({
              job: {
                applicants: [],
                property: {
                  address: result.properties[0].addresses[0],
                },
              },
            }),
          });
          const newResultResponse = await newResponse.json();
          // console.log(newResult.job);
          if (newResultResponse?.job?.program_options?.length > 0) {
            setSearchValueParam(searchValueParam);
            setNewResult(newResultResponse);
            setSearched(true);
            setFound(true);
          } else {
            setSearched(true);
            setFound(false);
            localStorage.clear();
          }
        } else {
          setSearched(true);
          setFound(false);
          localStorage.clear();
        }
      } catch (error) {
        console.log('error', error);
        setSearched(true);
        setFound(false);
        setLoading(false);
      }
    }
  };

  return (
    <div className="renew-search-container">
      {!searched && (
        <div>
          <div className="renew-search-text-first">PACE Home Improvement Financing</div>
          <div className="renew-search-text-second">
            A simple way to pay for energy and safety home improvements.
          </div>
          <div className="renew-search-text-third">
            Look up your home address to see if we're available in your community.
          </div>
        </div>
      )}
      {searched && !found && (
        <div>
          <div className="renew-search-text-fourth">
            We're sorry. Your address is outside of our coverage area
          </div>
          <div className="renew-search-text-fifth">
            Based on your home address {searchValue}, PACE is not yet available as a financing
            option.
          </div>
        </div>
      )}
      {searched && found && (
        <div>
          <div className="renew-search-text-sixth">
            Great news. Renew Financial is available in your community!
          </div>
          <div className="renew-search-text-seventh">
            Based on your home address {searchValue}, PACE is available as a financing option. Apply
            now to get your project started, or let us connect you with a contractor that is a best
            fit for your location and project.
          </div>
        </div>
      )}
      {!searched ? <SearchBar fetchData={fetchData} loading={loading} useCurrentLocation /> : null}
      {searched && !found && (
        <div className="button-stack">
          <button
            className="renew-primary-button"
            onClick={() => {
              setSearched(false);
            }}
          >
            <span>Check Another Address</span>
          </button>
          <button
            className="renew-primary-button"
            onClick={() => {
              window.open('https://form.jotform.com/RenewFinancial/pace-petition');
            }}
          >
            <span>Request Jurisdiction Approval</span>
          </button>
        </div>
      )}
      {searched && found && (
        <div className="button-stack">
          <button
            className="renew-primary-button"
            onClick={() => {
              localStorage.setItem('searchAddress', searchParams || '');
              localStorage.setItem('programData', JSON.stringify(newResult.job.program_options[0]));
              localStorage.setItem(
                'propertyData',
                JSON.stringify(newResult.job.property.addresses[0])
              );
              const contractorDataLocal = localStorage.getItem('contractorData');
              if (contractorDataLocal) {
                const contractorData = JSON.parse(contractorDataLocal);
                const contractorRegion = contractorData.region;
                const programRegion =
                  stateFromProgramName[newResult.job.program_options[0].program.name];
                if (contractorRegion !== programRegion) {
                  localStorage.removeItem('contractorData');
                }
              }
              window.location.href = `${window.location.protocol}//${window.location.host}/application`;
            }}
          >
            <span>Apply now</span>
          </button>
          <button
            className="renew-primary-button"
            onClick={() => {
              // window.location.reload();
              window.location.href = `${window.location.protocol}//${window.location.host}/homeowners`;
            }}
          >
            <span>Learn more</span>
          </button>
        </div>
      )}
    </div>
  );
}

export default HomeSearch;
